var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Block, findCutBefore, SylController, SylPlugin } from '@syllepsis/adapter';
import { NodeSelection, TextSelection } from 'prosemirror-state';
import { TableButton } from './component/menu-button';
import { NODE_NAME } from './const';
import { canSplitCell, closestTable, createTableNode, goToCell, judgeSelectAllTable, tableOperation } from './utils';
var TableItem = /** @class */ (function (_super) {
    __extends(TableItem, _super);
    function TableItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NODE_NAME.TABLE;
        _this.content = 'table_row+';
        _this.tableRole = 'table';
        _this.isolating = true;
        _this.notLastLine = true;
        _this.group = 'block';
        _this.parseDOM = [{ tag: 'table' }];
        _this.toDOM = function () { return ['table', ['tbody', 0]]; };
        return _this;
    }
    return TableItem;
}(Block));
var TableItemController = /** @class */ (function (_super) {
    __extends(TableItemController, _super);
    function TableItemController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = NODE_NAME.TABLE;
        _this.menuBtn = null;
        _this.$menu = null;
        _this.insertTable = function (_a) {
            var row = _a.row, column = _a.column;
            var node = createTableNode(row, column, {
                cellWidth: _this.props.defaultCellWidth,
                useTableHeader: _this.props.useTableHeader,
            });
            var index = _this.editor.getSelection().index;
            var $from = _this.editor.view.state.selection.$from;
            if (!node)
                return false;
            _this.editor.insert(node);
            var indexOffset = index + 3;
            if ($from && $from.node().childCount) {
                indexOffset = index + 5;
            }
            _this.editor.setSelection({
                index: indexOffset,
                length: 0,
            });
            return true;
        };
        _this.command = {
            insert: function (editor, row, column) { return _this.insertTable({ row: row, column: column }); },
            cut: function (editor) { return tableOperation.cut(editor); },
            copy: function (editor) { return tableOperation.copy(editor); },
            mergeCells: function (editor) { return tableOperation.mergeCells(editor); },
            splitCells: function (editor) { return tableOperation.splitCells(editor); },
            addRowBefore: function (editor) { return tableOperation.addRowBefore(editor); },
            addRowAfter: function (editor) { return tableOperation.addRowAfter(editor); },
            addColumnBefore: function (editor) { return tableOperation.addRowBefore(editor); },
            addColumnAfter: function (editor) { return tableOperation.addColumnAfter(editor); },
            deleteRow: function (editor) { return tableOperation.deleteRow(editor); },
            deleteColumn: function (editor) { return tableOperation.deleteColumn(editor); },
            deleteTable: function (editor) { return tableOperation.deleteTable(editor); },
            canSplitCell: function (editor) { return canSplitCell(editor); },
            goPrevCell: function (editor) {
                var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
                return goToCell(state, dispatch, -1);
            },
            goNextCell: function (editor) {
                var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
                return goToCell(state, dispatch);
            },
        };
        _this.keymap = {
            Tab: function (editor) { return _this.command.goNextCell(editor); },
            'Shift-Tab': function (editor) { return _this.command.goPrevCell(editor); },
            Backspace: function (editor, state, dispatch) {
                var _a = state.selection, $anchor = _a.$anchor, from = _a.from, to = _a.to;
                var tr = state.tr;
                if (judgeSelectAllTable(editor)) {
                    var $pos = state.selection.$anchor;
                    var node = $pos.node(1);
                    if (node.type.spec.tableRole !== 'table')
                        return false;
                    tr.setSelection(TextSelection.create(tr.doc, $pos.before(1), $pos.after(1))).deleteSelection();
                    dispatch(tr);
                    return true;
                }
                if (from !== to)
                    return false;
                var $cut = findCutBefore($anchor);
                if (!$cut)
                    return false;
                var before = $cut.nodeBefore;
                // currently empty, the previous is the node is table
                if (!before || before.type.spec.tableRole !== 'table' || $cut.pos !== from - 1)
                    return false;
                tr.setSelection(NodeSelection.create(state.doc, $cut.pos - before.nodeSize));
                dispatch(tr);
                return true;
            },
        };
        _this.toolbar = {
            name: NODE_NAME.TABLE,
            tooltip: NODE_NAME.TABLE,
            getRef: function (dom) {
                if (_this.$menu && _this.$menu !== dom && _this.menuBtn)
                    _this.menuBtn.unMount();
                _this.$menu = dom;
                _this.menuBtn = new TableButton(_this.editor, dom, _this.insertTable, _this.props || {});
            },
            handler: function (editor) { },
        };
        _this.disable = function (editor) { return Boolean(closestTable(editor.view.state.selection.$from)); };
        if (_this.props.trigger === 'hover')
            _this.toolbar.tooltip = false;
        return _this;
    }
    TableItemController.prototype.editorWillUnmount = function () {
        this.menuBtn && this.menuBtn.unMount();
    };
    return TableItemController;
}(SylController));
var TableItemPlugin = /** @class */ (function (_super) {
    __extends(TableItemPlugin, _super);
    function TableItemPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Controller = TableItemController;
        _this.Schema = TableItem;
        return _this;
    }
    return TableItemPlugin;
}(SylPlugin));
export { TableItem, TableItemController, TableItemPlugin };
//# sourceMappingURL=table-item.js.map